import React from 'react';
import styled from 'styled-components/macro';
import { withTranslation, WithTranslation } from 'react-i18next';
import { H2, P } from '../../../../components/Typography';
import { colors, distances, grid } from '../../../../styles/constants';

type Props = WithTranslation

const Container = styled.div`
    max-width: ${grid.spans.span7};
    margin: 0 auto 100px;
    padding: ${distances.normal};
    position: relative;
    min-height: calc(${distances.ginormous} + ${distances.large});
    border: 2px solid ${colors.borderLight};
`;

const NoCustomers = (
    {
        t,
    }: Props
) => {
    return (
        <Container>
            <H2>{t('customers.customer.discounts.no_discounts.title')}</H2>
            <br/>
            <br/>
            <P>{t('customers.customer.discounts.no_discounts.body')}</P>
        </Container>
    );
};

export default withTranslation()(NoCustomers);
